/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Activesessions2Inputs */

const zh_accountsettings_activesessions2 = /** @type {(inputs: Accountsettings_Activesessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活跃会话`)
};

const en_accountsettings_activesessions2 = /** @type {(inputs: Accountsettings_Activesessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Sessions`)
};

const es_accountsettings_activesessions2 = /** @type {(inputs: Accountsettings_Activesessions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones activas`)
};

/**
* | output |
* | --- |
* | "Active Sessions" |
*
* @param {Accountsettings_Activesessions2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_activesessions2 = /** @type {((inputs?: Accountsettings_Activesessions2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Activesessions2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_activesessions2(inputs)
	if (locale === "en") return en_accountsettings_activesessions2(inputs)
	return es_accountsettings_activesessions2(inputs)
});
export { accountsettings_activesessions2 as "accountSettings_activeSessions" }